import {ITransactionEvent} from '@/modules/Transactions/types';
import API from '@/services/spinampApi';
import {spinampServicesApi} from '@/services/spinampServicesApi';
import {IPlaybackEvent} from '@/types/events';
import {ISigner} from '@/types/session';
import {getSignedRequestBody} from '@/utils/api';

export const sendPlaybackEvents = async (
  events: IPlaybackEvent[],
  signer: ISigner,
): Promise<void> => {
  const body = await getSignedRequestBody(events, signer);

  return spinampServicesApi.post('/playbackEvent', body);
};

export const sendTransactionEvents = async (
  events: (ITransactionEvent & {platform: any})[],
  signer: ISigner,
): Promise<void> => {
  const body = await getSignedRequestBody(events, signer);

  return await API.post('/transactionEvent', body);
};
